/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React, { useState, Fragment, useEffect } from 'react';
import {
  Label,
  Input,
  Card,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  Badge,
  Tooltip
} from 'reactstrap';
import DocumentForm from './DocumentForm';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  AxiosAPI,
  getUserID,
  getGroupID,
} from '../../../../../helpers/AxiosAPI';
import { API_Documents, gAPI_Users_By_Id } from '../../../../../constants/APIs';
import moment from 'moment';
import Validation from '../../../../../components/Validation';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
  faTrashAlt,
  faEdit,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function generateRandomColor() {
  var arr = [
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'danger',
    'light',
    'dark',
  ];
  return arr[Math.floor(Math.random() * arr.length)];
}

const DocumentList = ({ match, documentList, tags, LoadData }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [comments, setComemnts] = useState('');
  const [documentDetails, setDocumentDetails] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [tagsColor, setTagsColor] = useState([]);
  const [isView, setIsView] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState({});

  const toggleTooltip = (id) => {
    setTooltipOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  useEffect(() => {
    if (tags !== undefined && tags.length > 0) {
      let lst = [];
      tags.map((m, index) => {
        lst.push({
          label: m,
          color: generateRandomColor(index),
        });
      });
      setTagsColor(lst);
    }
  }, [documentList]);

  const handleDeleteToggle = () => {
    setIsDelete(!isDelete);
  };

  const handleEditToggle = () => {
    setIsEdit(!isEdit);
  };
  const handleViewToggle = () => {
    setIsView(!isView);
  };
  const handleViewClick = (details) => {
    setDocumentDetails(details);
    handleViewToggle();
  };
  const handleEditClick = (details) => {
    setDocumentDetails(details);
    handleEditToggle();
  };

  const handleDeleteClick = (details) => {
    setDocumentDetails(details);
    handleDeleteToggle();
    setComemnts('');
  };

  const handleDelete = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      let body = {
        id: documentDetails.id,
        userName: res.data.fullName,
        comments: comments,
      };
      AxiosAPI({
        method: 'delete',
        url: `${API_Documents}`,
        data: body,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          handleDeleteToggle();
          LoadData();
        }
      });
    });
  };

  const handleUpdate = (item, primary) => {
    if (primary !== undefined) {
      if (primary) item.status = 'Published';
      else item.status = 'Draft';
    }

    item.modifiedBy = 'Admin';
    AxiosAPI({
      method: 'put',
      url: `${API_Documents}/${item.id}`,
      data: item,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        LoadData();
        if (isEdit === true) handleEditToggle();
      }
    });
  };

  const getFileType = (file) => {
    if (file.includes('docx')) return 'application/msword';
    else if (file.includes('pdf')) return 'application/pdf';
    else return 'text/plain';
  };

  const getfileExtension = (file) => {
    if (file.includes('docx')) return 'docx';
    else if (file.includes('pdf')) return 'pdf';
    else return 'txt';
  };

  const handleDownload = (item) => {
    NotificationManager.success(
      '',
      'Please wait, it will take a few moments to download the document',
      3000,
      null,
      null,
      'success'
    );
    AxiosAPI({
      method: 'GET',
      url: `${API_Documents}/download/${item.id}`,
    })
      .then((response) => {
        let link = document.createElement('a');
        const mimeType = getFileType(response.data.fileName);
        link.href = `data:${mimeType};base64,${response.data.content}`;
        link.download = `${item.title}.${getfileExtension(
          response.data.fileName
        )}`;
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // console.log('doc', documentList)
  return (
    <>
      <Card
        className="d-flex flex-row "
        style={{
          borderRadius: '10px',
          backgroundColor: 'var(--theme-color-2)',
          marginBottom: '20px',
        }}
      >
        <div className="pl-2 d-flex flex-grow-1 min-width-zero">
          <div
            className="card-body align-self-center d-flex flex-column flex-lg-row text-white"
            style={{ marginTop: '4px' }}
          >
            <p className="mb-1 ml-5 text-small font-weight-bold w-40 w-sm-100">
              Webpage
            </p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">
              Tags
            </p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">
              Source
            </p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">
              Status
            </p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">
              Date Created
            </p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">
              Date Modified
            </p>
            <p className="mb-1 text-small font-weight-bold w-10 w-sm-100">
              Published
            </p>
            <p className="mb-1 text-small font-weight-bold w-15 w-sm-100">
              Download
            </p>
            <p className="mb-1 text-small font-weight-bold w-10 w-sm-100">
              Actions
            </p>
          </div>
        </div>
      </Card>

      {documentList !== undefined &&
        documentList.length > 0 &&
        documentList.map((item) => (
          <Card
            className="d-flex flex-row mb-3"
            style={{ borderRadius: '10px' }}
          >
            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
              <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <p className="mb-1 ml-5  text-small w-40 w-sm-100">
                  <b>{item.title}</b>
                  <p className="mt-2">({item.id})</p>
                </p>

                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                  {/* {FormsType.filter(i => i.value.includes(item.formType)).map(p => p.label)} */}
                  {item.tags.length > 0 &&
                    item.tags.map((m, i) => (
                      <Badge
                        color={
                          tagsColor?.find((f) => f.label === m)?.color ?? 'secondary'
                        }
                        className="mt-1 mr-1"
                      >
                        {m}
                      </Badge>
                    ))}
                </p>
                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                  {item.creator === 'WebPage' ? (
                    <IntlMessages id="dashboards.webpage" />
                  ) : (
                    item.creator
                  )}
                </p>
                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                  {item.status === 'ReadyToPublish' ? (
                    'Ready To Publish'
                  ) : item.status === 'Published' ? (
                    <IntlMessages id="dashboards.published" />
                  ) : item.status === 'Draft' ? (
                    <IntlMessages id="dashboards.draft" />
                  ) : (
                    item.status
                  )}
                </p>
                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                  {moment(item.date).format('MMM DD, YYYY hh:mm')}
                </p>
                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                  {moment(item.lastModified).format('YYYY') === '0001'
                    ? ''
                    : moment(item.lastModified).format('MMM DD, YYYY hh:mm')}
                </p>
                <p className="mb-1 text-muted text-small w-10 w-sm-100">
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small"
                    checked={item.status === 'Draft' ? false : true}
                    onChange={(primary) => handleUpdate(item, primary)}
                  />
                </p>
                <div className="mb-1 w-15 w-sm-100">
                  <Button
                    color="secondary"
                    size="xs"
                    outline
                    onClick={() => handleDownload(item)}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>{' '}
                    <IntlMessages id="dashboards.download" />
                  </Button>
                </div>
                <div className="mb-1 w-10 w-sm-100">
                  {item.creator === 'WebPage' || item.creator === 'SynXis' ? (
                    <div>
                      <i
                        onClick={() => handleViewClick(item)}
                        style={{ cursor: 'pointer' }}
                        className="icon-open"
                        title="View"
                      >
                        <svg
                          fill="none"
                          height="20"
                          viewBox="0 0 24 24"
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14"
                            stroke="#90caf9"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                        </svg>
                      </i>
                      <Fragment>
                        <b> | </b>
                        <FontAwesomeIcon
                          id={`delete-icon-${item.id}`}
                          icon={faTrashAlt}
                          style={{
                            color: 'var(--theme-color-1)',
                            cursor: 'pointer',
                          }}
                          onClick={() => handleDeleteClick(item)}
                        />
                        <Tooltip
                          placement="top"
                          isOpen={tooltipOpen[item.id] || false}
                          target={`delete-icon-${item.id}`}
                          toggle={() => toggleTooltip(item.id)}
                        >
                          This action will delete the file.
                          <br />
                          If External Sources is still active, the file will be
                          created during next Sync event.
                        </Tooltip>
                      </Fragment>
                    </div>
                  ) : (
                    <div>
                      <FontAwesomeIcon
                        icon={faEdit}
                        color="#90caf9"
                        cursor="pointer"
                        title="Edit"
                        onClick={() => handleEditClick(item)}
                      />
                      <Fragment>
                        <b> | </b>
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          style={{ color: 'var(--theme-color-1)' }}
                          cursor="pointer"
                          title="Delete"
                          onClick={() => handleDeleteClick(item)}
                        />
                      </Fragment>
                    </div>
                  )}
                  {/* <div className="mb-1 w-10 w-sm-100">
                                        <UncontrolledDropdown className="w-15 text-center w-sm-100" >
                                            <DropdownToggle caret color="outline-dark" size="xs">
                                                more
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem
                                                    key="edit"
                                                    onClick={() => handleEditClick(item)}
                                                >
                                                    View Details
                                                </DropdownItem>
                                                <DropdownItem
                                                    key="danger"
                                                    onClick={() => handleDeleteClick(item)}
                                                >
                                                    Delete Document
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div> */}
                </div>
              </div>
            </div>
          </Card>
        ))}
      {isEdit && documentDetails !== undefined && (
        <DocumentForm
          taglist={tags}
          label={'Update Document'}
          documentDetails={documentDetails}
          toggle={handleEditToggle}
          submit={handleUpdate}
          visible={isEdit}
        ></DocumentForm>
      )}
      {isView && documentDetails !== undefined && (
        <DocumentForm
          taglist={tags}
          label={'View Document'}
          documentDetails={documentDetails}
          toggle={handleViewToggle}
          submit={handleUpdate}
          visible={isView}
        ></DocumentForm>
      )}
      {isDelete && documentDetails !== undefined && (
        <Modal
          isOpen={isDelete}
          toggle={handleDeleteToggle}
          style={{ maxWidth: '600px' }}
        >
          <ModalHeader toggle={handleDeleteToggle}>Delete Document</ModalHeader>
          <ModalBody>
            <h6 className="mb-3">Are you sure you want to delete ?</h6>

            <div className="mb-3">
              <Label>Comments</Label>
              <Input
                type="text"
                name="comments"
                value={comments}
                onChange={(e) => {
                  setComemnts(e.target.value);
                }}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={handleDelete}>
              Delete
            </Button>
            <Button color="secondary" onClick={handleDeleteToggle}>
              Back
            </Button>
          </ModalFooter>
        </Modal>
      )}
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </>
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(DocumentList));
